export default "__VITE_ASSET__9dea5641__"